import React, { memo } from 'react'
import { util } from '../../../util'

const TableHead = ({ className, children }) => (
    <thead data-testid={'table__head'} className={util.joinClasses('table__head', className)}>
        {children}
    </thead>
)

export default memo(TableHead)
